import { trackEvent } from '@shared/lib/amplitude'
import { toAnalyticsId } from '@shared/lib/amplitude'

import { useVoipRoomStore } from '../model/voip-room-store'
import { useLessonRoomStore } from '../model/store'

type ClassroomEventName = Parameters<typeof trackEvent>[0]
type ClassroomEventProps = NonNullable<Parameters<typeof trackEvent>[1]>

/** Lesson-room events: `feature: classroom` plus the room context EVENT_PROPS says the tracker attaches. */
export const trackClassroomEvent = (name: ClassroomEventName, props: ClassroomEventProps = {}): void => {
  const room = useVoipRoomStore().getRoomData
  const booking = useLessonRoomStore().getBooking

  trackEvent(name, {
    feature: 'classroom',
    room_provider: room?.provider ? toAnalyticsId(room.provider) : null,
    room_type: booking?.room_data?.type ?? null,
    booking_id: booking?.id ?? null,
    ...props,
  })
}

interface MediaPermissionStatuses {
  micStatus: string
  camStatus: string
}

const permissionState = (status: string): string => (status === 'Blocked' ? 'denied' : 'granted')

/** A camera / microphone denial is a browser-API error; the modal it opens sends its own Popup_view. */
export const trackMediaPermissionError = (name: string, { micStatus, camStatus }: MediaPermissionStatuses): void => {
  trackClassroomEvent('App_error', {
    name,
    error_code: 'permission_denied',
    microphone_permission: permissionState(micStatus),
    camera_permission: permissionState(camStatus),
  })
}
